import { useCallback, useEffect, useState } from 'react'

import { getDashboardMetricCards } from '@/api/dashboard'
import { DashboardMetricCardsResponseModel } from '@/types/dashboard'
import { DateType } from '@/utils'

export default function useDashboardMetricCards(
  startDate: string,
  endDate: string,
  branches: string,
  dateType: DateType
) {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)
  const [metricCards, setMetricCards] =
    useState<DashboardMetricCardsResponseModel>()

  const fetchAllData = useCallback(async () => {
    if (!branches || !startDate || !endDate) {
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const metricCardsResponse = await getDashboardMetricCards(
        branches,
        startDate,
        endDate,
        dateType
      )

      setMetricCards(metricCardsResponse)
    } catch (err) {
      setError(
        new Error(
          err instanceof Error ? err.message : 'An unknown error occurred'
        )
      )
    } finally {
      setLoading(false)
    }
  }, [branches, startDate, endDate])

  const refetch = useCallback(() => {
    console.log('Refetching dashboard metric cards data...')
    return fetchAllData()
  }, [fetchAllData])

  useEffect(() => {
    fetchAllData()
  }, [fetchAllData])

  return {
    metricCards,
    loading,
    error,
    refetch,
  }
}
